import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Services from "@/components/landing/Services";
import HowItWorks from "@/components/landing/HowItWorks";
import Fleet from "@/components/landing/Fleet";
import Testimonials from "@/components/landing/Testimonials";
import ContactMap from "@/components/landing/ContactMap";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import GoogleMapsProvider from "@/components/landing/GoogleMapsProvider";
import AdminDashboard from "@/pages/AdminDashboard";

function LandingPage() {
  return (
    <GoogleMapsProvider>
      <div className="App min-h-screen bg-white text-[#0F172A]" data-testid="cabsab-landing-root">
        <Navbar />
        <main>
          <Hero />
          <WhyChooseUs />
          <Services />
          <HowItWorks />
          <Fleet />
          <Testimonials />
          <ContactMap />
        </main>
        <Footer />
        <FloatingActions />
      </div>
    </GoogleMapsProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
